import { lazy } from 'react'
import { IModuleDefinition } from '../types'

const AdminContainer = lazy(() => import('./AdminContainer'))

const moduleDefinition: IModuleDefinition = {
  routeProps: {
    path: '/admin/*',
    private: true,
    component: AdminContainer
  },
  name: 'Admin'
}

export default moduleDefinition
